import React from 'react'

const Focus = (props) => {
    return (
        <p>{props.focus.Name}</p>
    )
}

export default Focus